export const laptopStorageOptions = [
    { value: "512gb", label: "512GB" },
    { value: "1tb", label: "1TB" },
    { value: "2tb", label: "2TB" },
  ];

  export const laptopOSOptions = [
    {value:"MacOS",label:'MacOS'},
    {value:"Windows",label:'Windows'},
    {value:"Linux",label:'Linux'},
]

export const laptopColorOptions = [
    {value:"Black",label:'Black'},
    {value:"Silvar",label:'Silvar'},
    {value:"White",label:'White'},
]

export const laptopBrandOptions = [
  {value:"apple",label:'Apple'},
  {value:"samsung",label:'Samsung'},
  {value:"hp",label:'Hp'},
  {value:"Sony",label:'Sony'},
  {value:"lenovo",label:'Lenovo'},
]
